module.exports = __webpack_public_path__ + "static/media/scanning-compounds-to-repurpose.0d2bf8c9.jpg";